import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';
import { providerInfo, clinicInfo } from '../../mock';

export const HeroSection = ({ scrollToSection }) => (
  <section id="home" data-testid="hero-section" className="pt-[38px] md:pt-[350px] lg:pt-[420px] pb-10 md:pb-20 px-4 relative z-10">
    <div className="container mx-auto relative z-10">
      {/* Mobile Logo - Centered, positioned very close to title (80% less gap) */}
      <div className="md:hidden flex justify-center -mb-2">
        <img
          src={clinicInfo.logo}
          alt="FAVOR HCS Logo"
          className="w-[280px] h-auto max-w-[85vw] drop-shadow-[0_6px_16px_rgba(74,44,32,0.12)]"
        />
      </div>
      
      <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
        <div className="space-y-4 md:space-y-6 animate-in fade-in slide-in-from-left">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-darkBrown leading-tight">
            Psychiatric Services in <span className="text-primaryOrange">Humble, Texas</span>
          </h1>
          <p className="text-base md:text-xl text-gray-700 leading-relaxed">
            Compassionate, integrative, and truly client-centered care for children and adults.
          </p>
          <p className="text-sm md:text-lg text-gray-600">
            {providerInfo.name} is a board-certified psychiatric mental health nurse practitioner with {providerInfo.experience.toLowerCase()}.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            <Button
              data-testid="hero-book-appointment-btn"
              onClick={() => scrollToSection('appointment')}
              size="lg"
              className="bg-primaryOrange hover:bg-accentOrange text-white shadow-lg hover:shadow-xl transition-all w-full sm:w-auto"
            >
              Book Appointment
              <ChevronRight className="ml-2" size={20} />
            </Button>
            <Button
              data-testid="hero-view-services-btn"
              onClick={() => scrollToSection('services')}
              size="lg"
              variant="outline"
              className="border-primaryOrange text-primaryOrange hover:bg-primaryOrange hover:text-white transition-all w-full sm:w-auto"
            >
              View Services
            </Button>
          </div>
        </div>
        
        {/* Desktop Photo - Static single image */}
        <div className="relative animate-in fade-in slide-in-from-right hidden md:block">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-white p-4">
            <img
              src="https://customer-assets.emergentagent.com/job_26f08e10-1414-438b-96d5-f47b988c9439/artifacts/xmugi9mo_Photo%201.jpg"
              alt="Professional portrait"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
);
